import * as moment from "moment";
import { auth, database } from "../firebase";

export const fetchAllPipelines = async (info) => {
  try {
    const allPipelines = [];
    const pipelines = await database
      .collection("companies")
      .doc(info.companyId)
      .collection("pipelines")
      .get();
    if (pipelines.size > 0) {
      pipelines.forEach((pipeline) => {
        allPipelines.push({ name: pipeline.data().name, id: pipeline.id });
      });
    }
    return Promise.all(allPipelines).then((result) => {
      return { payload: allPipelines, error: null };
    });
  } catch (e) {
    throw new Error(e);
  }
};

export const retrieveSinglePipeline = async (info) => {
  try {
    const details = await fetchPipelineInfo(info);
    const units = await fetchPipelineUnits(info);
    const data = await fetchPipelineData(info);

    const pipeline = {
      id: details.id,
      name: details.name,
      units: units && units.length > 0 ? units : [],
      data: data && data.length > 0 ? data : [],
    };

    return { payload: pipeline, error: null };
  } catch (e) {
    throw new Error(e);
  }
};

export const fetchPipelineInfo = async (info) => {
  try {
    const details = await database
      .collection("companies")
      .doc(info.companyId)
      .collection("pipelines")
      .doc(info.pipelineId)
      .get();

    return {
      name: details.data().name ? details.data().name : null,
      id: details.id,
    };
  } catch (e) {
    throw new Error(e);
  }
};

export const fetchPipelineUnits = async (info) => {
  try {
    const allUnits = [];
    const units = await database
      .collection("companies")
      .doc(info.companyId)
      .collection("pipelines")
      .doc(info.pipelineId)
      .collection("units")
      .orderBy("order")
      .get();
    units.forEach((unit) => {
      allUnits.push({
        name: unit.data().name,
        id: unit.id,
        order: unit.data().order,
      });
    });

    return Promise.all(allUnits).then((result) => {
      return result;
    });
  } catch (e) {
    throw new Error(e);
  }
};

export const fetchPipelineData = async (info) => {
  try {
    const allData = [];
    const units = await database
      .collection("companies")
      .doc(info.companyId)
      .collection("pipelines")
      .doc(info.pipelineId)
      .collection("data")
      .orderBy("index")
      .get();

    units.forEach((unit) => {
      allData.push({
        index: unit.data().index,
        id: unit.id,
        target: unit.data().target,
        title: unit.data().title,
        description: unit.data().description,
        type: unit.data().type,
        amount: parseInt(unit.data().amount),
        name: unit.data().name,
        contactPerson: unit.data().contactPerson,
        dateAdded: unit.data().dateAdded,
      });
    });

    return Promise.all(allData).then((result) => {
      return result;
    });
  } catch (e) {
    throw new Error(e);
  }
};

export const performMovePipelineData = async (info) => {
  try {
    if (info.destinationId && info.destinationItems) {
      const allSourceUpdates = [];
      const allDestUpdates = [];
      for (var unit in info.sourceItems) {
        const index = info.sourceItems.findIndex(
          (obj) => obj.id === info.sourceItems[unit].id
        );
        const update = updateSingleUnitTarget(
          info.companyId,
          info.pipelineId,
          info.sourceItems[unit].id,
          index,
          info.sourceId
        );
        allSourceUpdates.push(update);
      }
      for (var unit in info.destinationItems) {
        const index = info.destinationItems.findIndex(
          (obj) => obj.id === info.destinationItems[unit].id
        );
        const update = updateSingleUnitTarget(
          info.companyId,
          info.pipelineId,
          info.destinationItems[unit].id,
          index,
          info.destinationId
        );
        allDestUpdates.push(update);
      }

      return Promise.all([allSourceUpdates, allDestUpdates]).then((result) => {
        return { payload: "success", error: null };
      });
    } else {
      const allUpdates = [];
      for (var unit in info.sourceItems) {
        const index = info.sourceItems.findIndex(
          (obj) => obj.id === info.sourceItems[unit].id
        );
        const update = updateSingleUnitIndex(
          info.companyId,
          info.pipelineId,
          info.sourceItems[unit].id,
          index
        );
        allUpdates.push(update);
      }
      return Promise.all(allUpdates).then((result) => {
        return { payload: "success", error: null };
      });
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const updateSingleUnitIndex = (companyId, pipelineId, unitId, index) => {
  return new Promise((resolve, reject) => {
    database
      .collection("companies")
      .doc(companyId)
      .collection("pipelines")
      .doc(pipelineId)
      .collection("data")
      .doc(unitId)
      .update({ index: index })
      .then((update) => {
        resolve(true);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const updateSingleUnitTarget = (
  companyId,
  pipelineId,
  unitId,
  index,
  targetId
) => {
  return new Promise((resolve, reject) => {
    database
      .collection("companies")
      .doc(companyId)
      .collection("pipelines")
      .doc(pipelineId)
      .collection("data")
      .doc(unitId)
      .update({ index: index, target: targetId })
      .then((update) => {
        resolve(true);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const performFetchUpdatedPipelineData = async (info) => {
  try {
    const details = await fetchPipelineInfo(info);
    const units = await fetchPipelineUnits(info);
    const data = await fetchPipelineData(info);

    const pipeline = {
      id: details.id,
      name: details.name,
      units: units,
      data: data,
    };

    return { payload: pipeline, error: null };
  } catch (e) {
    throw new Error(e);
  }
};

export const fetchNewCompanyInformation = (organizationNumber) => {
  return new Promise((resolve, reject) => {
    fetch(`/api/1881/details/${organizationNumber}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        resolve(data);
      })
      .catch((e) => {
        throw new Error(e);
      });
  });
};

export const createNewSingleOpportunity = async (info) => {
  try {
    if (info && info.details && info.details.type) {
      if (info.details.type === "company") {
        const unit = await database
          .collection("companies")
          .doc(info.companyId)
          .collection("pipelines")
          .doc(info.pipelineId)
          .collection("data")
          .add({
            amount: parseInt(info.details.amount.toString().replace(/ /g, "")),
            addedBy: auth.currentUser.uid,
            name: info.details.name,
            type: info.details.type,
            description: info.details.description
              ? info.details.description
              : null,
            index: 0,
            target: info.details.unit,
            title: info.details.title,
            contactPerson: info.details.contactPerson,
            dateAdded: moment().unix(),
          });
      } else if (info.details.type === "person") {
        const unit = await database
          .collection("companies")
          .doc(info.companyId)
          .collection("pipelines")
          .doc(info.pipelineId)
          .collection("data")
          .add({
            amount: parseInt(info.details.amount.toString().replace(/ /g, "")),
            addedBy: auth.currentUser.uid,
            name: `${info.details.firstName} ${info.details.lastName}`,
            type: info.details.type,
            description: info.details.description
              ? info.details.description
              : null,
            index: 0,
            target: info.details.unit,
            title: info.details.title,
            contactPerson: `${info.details.firstName} ${info.details.lastName}`,
            dateAdded: moment().unix(),
          });
      }
    }
    return { error: null };
  } catch (e) {
    throw new Error(e);
  }
};

export const updateSingleOpportunity = async (info) => {
  try {
    await database
      .collection("companies")
      .doc(info.companyId)
      .collection("pipelines")
      .doc(info.pipelineId)
      .collection("data")
      .doc(info.unit.id)
      .update({
        title: info.unit.title,
        amount: parseInt(info.unit.amount.toString().replace(/ /g, "")),
        description: info.unit.description,
        contactPerson: info.unit.contactPerson,
      });
    return { error: null };
  } catch (e) {
    throw new Error(e);
  }
};

export const deleteSingleOpportunity = async (info) => {
  try {
    await database
      .collection("companies")
      .doc(info.companyId)
      .collection("pipelines")
      .doc(info.pipelineId)
      .collection("data")
      .doc(info.unitId)
      .delete();
    return { error: null };
  } catch (e) {
    throw new Error(e);
  }
};

export const createNewPipeline = async (info) => {
  try {
    const pipeline = await database
      .collection("companies")
      .doc(info.companyId)
      .collection("pipelines")
      .add({ name: info.name });
    const pipelineId = pipeline.id;

    const units = [];

    for (var unit in info.units) {
      const add = await database
        .collection("companies")
        .doc(info.companyId)
        .collection("pipelines")
        .doc(pipelineId)
        .collection("units")
        .add({ order: info.units[unit].order, name: info.units[unit].name });
      units.push(add);
    }

    return Promise.all(units)
      .then(() => {
        return { error: null, id: pipelineId };
      })
      .catch((e) => {
        throw new Error(e);
      });
  } catch (e) {
    throw new Error(e);
  }
};

export const updatePipeline = async (pipelineInfo) => {
  try {
    await database
      .collection("companies")
      .doc(pipelineInfo.companyId)
      .collection("pipelines")
      .doc(pipelineInfo.pipelineId)
      .update({ name: pipelineInfo.name });

    const updates = [];
    const deletions = [];

    for (var unit in pipelineInfo.units) {
      const singleUpdate = await updateSingleUnit(
        pipelineInfo,
        pipelineInfo.units[unit]
      );
      updates.push(singleUpdate);
    }

    if (pipelineInfo.deletions && pipelineInfo.deletions.length > 0) {
      for (var deletion in pipelineInfo.deletions) {
        const singleDeletion = await deleteSingleUnit(
          pipelineInfo,
          pipelineInfo.deletions[deletion]
        );
        deletions.push(singleDeletion);
      }
    }

    return Promise.all([updates, deletions]).then((results) => {
      return { error: null, id: pipelineInfo.pipelineId };
    });
  } catch (e) {
    throw new Error(e);
  }
};

export const deletePipeline = async (details) => {
  try {
    await database
      .collection("companies")
      .doc(details.companyId)
      .collection("pipelines")
      .doc(details.pipelineId)
      .delete();

    return { error: null };
  } catch (e) {
    throw new Error(e);
  }
};

export const updateSingleUnit = async (details, unit) => {
  try {
    const single = await database
      .collection("companies")
      .doc(details.companyId)
      .collection("pipelines")
      .doc(details.pipelineId)
      .collection("units")
      .doc(unit.id)
      .get();
    if (single.exists) {
      await database
        .collection("companies")
        .doc(details.companyId)
        .collection("pipelines")
        .doc(details.pipelineId)
        .collection("units")
        .doc(unit.id)
        .update({ name: unit.name, order: unit.order });
    } else {
      await database
        .collection("companies")
        .doc(details.companyId)
        .collection("pipelines")
        .doc(details.pipelineId)
        .collection("units")
        .add({ name: unit.name, order: unit.order });
    }
    return unit.id;
  } catch (e) {
    throw new Error(e);
  }
};

export const deleteSingleUnit = async (details, unitId) => {
  try {
    await database
      .collection("companies")
      .doc(details.companyId)
      .collection("pipelines")
      .doc(details.pipelineId)
      .collection("units")
      .doc(unitId)
      .delete();
    return unitId;
  } catch (e) {
    throw new Error(e);
  }
};
